export default __webpack_public_path__ + "static/gov-messaging-4e64476ee8f06a99e76fc0fbf1894ea7.png";